module.exports = __webpack_public_path__ + "static/media/ZM.3ec35fdb.svg";